import { findLastIndex } from 'lodash-es';
import { ITournamentMatchShotData } from 'twain-sport-fe-mono/interfaces';

interface IScoresListItem extends Pick<ITournamentMatchShotData, 'isSuccessful'> {
    key: string;
    fill: boolean;
    current: boolean;
    animate: boolean;
}

export const generateScoresList = (
    scoresItemsCount: number,
    scoresList: ITournamentMatchShotData[],
    animate: IScoresListItem['animate'],
    historical?: boolean,
): IScoresListItem[] => {
    const lastShot = findLastIndex(scoresList, (item) => item?.isSuccessful !== null);

    return new Array(scoresItemsCount).fill(null).map((item, index) => {
        const scoreItem = scoresList[index] ?? { order: -index, isSuccessful: false };
        return {
            key: `${scoreItem.order}_${index}`,
            isSuccessful: scoreItem.isSuccessful,
            fill: historical ? index < lastShot : index < scoresList.length,
            current: index === scoresList.length,
            animate: index === scoresList.length - 1 && animate,
        };
    });
};
